<script setup lang="ts">
import { useRouter } from "vue-router";

import LoginForm from "@/components/LoginForm.vue";
import LogoImage from "@/assets/icons/favicon.svg";
import { definePage } from "unplugin-vue-router/runtime";
definePage({
  meta: {
    title: "Login",
    fullscreen: true,
  },
});

const logoImage = LogoImage;

const router = useRouter();
const loginSuccess = () => {
  router.push({
    name: "dashboard",
  });
};
</script>

<template>
  <v-container class="login">
    <v-row>
      <v-col align="center">
        <v-img
          :src="logoImage"
          :width="150"
          aspect-ratio="1/1"
          contain
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col
        cols="12"
        md="4"
        offset-md="4"
      >
        <v-sheet
          class="mx-auto pa-6"
          border
          rounded="xl"
        >
          <LoginForm @login-success="loginSuccess" />
        </v-sheet>
      </v-col>
    </v-row>
  </v-container>
</template>
